import React from 'react';
import styled from 'styled-components';
import { DayPicker } from 'datepicker-wrap';

const DateFilter = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  disabled,
}) => (
  <Wrapper>
    <DayPicker
      selected={startDate}
      selectsStart
      startDate={startDate}
      endDate={endDate}
      width="200px"
      onChange={newStartDate => {
        // If startDate is later than endDate
        if (endDate.diff(newStartDate, 'days') < 0) {
          setEndDate(newStartDate);
        }
        setStartDate(newStartDate);
      }}
      disabled={disabled}
    />
    <Dash>-</Dash>
    <DayPicker
      selected={endDate}
      selectsEnd
      startDate={startDate}
      endDate={endDate}
      onChange={newEndDate => {
        // If endDate is earlier than startDate
        if (startDate.diff(newEndDate, 'days') > 0) {
          setStartDate(newEndDate);
        }
        setEndDate(newEndDate);
      }}
      disabled={disabled}
    />
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
`;

const Dash = styled.div`
  flex: none;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default DateFilter;
